import React from "react";
import "../style.css";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorText: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorText: error?.message || "Something went wrong" };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }

  handleReload = () => window.location.reload();

  render() {
    if (this.state.hasError) {
      return (
        <div className="global-error">
          <div className="global-error-box">
            <div className="global-error-emoji">⚠️</div>
            <h2>Something went wrong</h2>
            <p>{this.state.errorText}</p>
            <button className="btn-primary" onClick={this.handleReload}>
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
